module.exports = __webpack_public_path__ + "img/wz-2-3.de999443.png";